// PD-16827 — filters of the client account's order-time license copies list
// (the orders whose license evidence was copied onto them at submit), shown in
// the Licenses tab's "Download licensing" dialog. The date range picks which
// order copies the licensing download includes.

import { createDateRangeFilter } from './factories';
import type { FilterRegistry } from './types';

const LICENSE_ORDER_COPY_LIST_KEYS: ReadonlyArray<string> = [
	'license-order-copy-client-embedded',
];

export const licenseOrderCopyFilters: FilterRegistry = {
	licenseOrderCopyDateRange: {
		...createDateRangeFilter({
			label: 'Order Date',
			objectTable: 'order',
			dateField: 'date',
			listKeys: [...LICENSE_ORDER_COPY_LIST_KEYS],
		}),
		queryParamName: 'licenseOrderCopyDateRange',
	},
};
